import React, { Component } from 'react';
import {
  Image,
  ImageBackground,
  Platform,
  ScrollView,
  StyleSheet,
  Text,
  TouchableOpacity,
  View,
} from 'react-native';

import EonnButton2 from '../components/button2';
import EonnLink from '../components/link';
import { mstyles } from '../constants/MainStyles';
import { SafeAreaView } from 'react-native-safe-area-context';

const styles = StyleSheet.create({
  logo: {
    width: '100%',
    height: null,
    aspectRatio: 2.27,
    resizeMode: 'contain',
    marginBottom: 30,
  },
  logoContainer: {
    position: 'relative',
    width: '100%',
    marginBottom: 30,
  },
  techOverlay: {
    position: 'absolute',
    top: '40%',
    left: '50%',
    marginLeft: -40, // Half of profile image width to center horizontally
    marginTop: -50, // Adjust vertical positioning
    alignItems: 'center',
    zIndex: 10,
  },
  techProfileImage: {
    width: 80,
    height: 80,
    borderRadius: 40,
    borderWidth: 3,
    borderColor: '#fff',
    marginBottom: 10,
  },
  techName: {
    fontSize: 18,
    fontWeight: 'bold',
    color: '#fff',
    textAlign: 'center',
    textShadowColor: 'rgba(0, 0, 0, 0.75)',
    textShadowOffset: { width: 1, height: 1 },
    textShadowRadius: 2,
  },
  title: {
    fontSize: 35,
    lineHeight: 35,
    maxWidth: 250,
    textAlign: 'center',
  },
  container: {
    flex: 1,
    flexDirection: 'row',
    backgroundColor: '#f9f9fd',
  },
  content: {
    paddingBottom: 30,
    flexDirection: 'column',
  },
  center: {
    width: 650,
    maxWidth: '100%',
  },
  side: {
    flex: 1,
  }
});

export default class Screen extends Component {
  
  constructor(props) {
    super(props);
  }
  
  render() {
    const hasTechLink = !!global.techLink;
    const logoSource = hasTechLink 
      ? require('../assets/images/intro-logo2.png')
      : require('../assets/images/intro-logo.png');
    
    return (
      <SafeAreaView style={styles.container}>
        <View style={styles.side}></View>
        <ImageBackground
          source={require('../assets/images/bg3.jpg')}
          style={styles.center}
        >
          <ScrollView contentContainerStyle={[mstyles.content,mstyles.center]}>
            <View style={styles.logoContainer}>
              <Image
                source={logoSource}
                style={styles.logo}
              />
              {hasTechLink && global.bid && (
                <View style={styles.techOverlay}>
                  {global.bid.t_profilePicture ? (
                    <Image
                      source={{uri: global.bid.t_profilePicture}}
                      style={styles.techProfileImage}
                    />
                  ) : (
                    <Image
                      source={require('../assets/images/portrait1.png')}
                      style={styles.techProfileImage}
                    />
                  )}
                  <Text style={[mstyles.mfont, styles.techName]}>
                    {global.bid.t_name || 'Auto Tech'}
                  </Text>
                </View>
              )}
            </View>
            <Text style={[mstyles.title,styles.title]}>Having Car Issues?</Text>
            <EonnButton2
              navigationProps={this.props.navigation}
              image={require('../assets/images/button1.png')}
              style={{marginBottom: 70}}
              lines={[
                {text: 'TALK WITH AN', size: 27},
                {text: 'AUTO TECH NOW', size: 22.6},
              ]}
              screen={'C_Profile1'}
            ></EonnButton2>
            <EonnLink>Log In</EonnLink>
            <EonnLink>Help</EonnLink>
          </ScrollView>
        </ImageBackground>
        <View style={styles.side}></View>
      </SafeAreaView>
    );
  }
}